import { Stack, Typography } from '@mui/material';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ImageComponent from 'src/components/common/Image';
import ModalComponent from 'src/components/Modal/ModalComponent';
import { useNotification } from 'src/hooks/useNotification';
import useRefetch from 'src/hooks/useRefetch';
import { useMutateSubscriptionFreeTrial } from 'src/services/mutate';
import { QUERY_KEY_USAGE } from 'src/services/queries';

// Utilities
import { ICON_CONFIRM_GET_TRIAL } from 'src/utils/constants/imagesUrl';
import { SUCCESS_CODE } from 'src/utils/constants/statusCode';
import { renderNumberOrDefault } from 'src/utils/helpers/stringHelpers';

const PopupConfirmSpecialTrial = ({
  planId,
  open,
  creditPoints,
  affiliateCode,
  campaignSlug,
  handleClose,
}: {
  planId: number;
  open: boolean;
  creditPoints: number;
  affiliateCode?: string;
  campaignSlug?: string;
  handleClose: () => void;
}) => {
  const { notification } = useNotification();
  const { mutateAsync, isPending } = useMutateSubscriptionFreeTrial();
  const { refetchQuery } = useRefetch();

  const handleChangePrice = async () => {
    const responseSubscription = await mutateAsync({ planId, affiliateCode, campaignSlug });

    notification(responseSubscription);
    if (responseSubscription?.status_code === SUCCESS_CODE.GET) {
      refetchQuery([QUERY_KEY_USAGE]);
      handleClose();
    }
  };

  return (
    <ModalComponent
      padding={4}
      open={open}
      handleClose={() => {
        handleClose();
      }}
      showCloseIcon={true}
    >
      <Stack direction="column" spacing={2} width={504} alignItems="center">
        {/* <ImageComponent imgSrc={ICON_CONFIRM_GET_TRIAL} height={150} /> */}

        <Typography textAlign="center" variant="h6">
          Get Special Offer Now
        </Typography>
        <Typography textAlign="center" variant="body1">
          Switch to Free package, no card information required. Please confirm and get{' '}
          <Typography component="span" color="secondary.main">
            {renderNumberOrDefault(creditPoints)} Credits
          </Typography>{' '}
          now.
        </Typography>
        <ButtonWithLoading
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            handleChangePrice();
          }}
          fullWidth
          isLoading={isPending}
          disabled={isPending}
        >
          Yes, change me to the free package now
        </ButtonWithLoading>
      </Stack>
    </ModalComponent>
  );
};

export default PopupConfirmSpecialTrial;
